import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "./AuthContext"
import { Box, CircularProgress } from "@mui/material"

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */

function ProtectedRoute({ children }: { children: JSX.Element }) {
    const { user, loading } = useAuth()
    const location = useLocation()

    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                }}
            >
                <CircularProgress />
            </Box>
        )
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return children
}

export default ProtectedRoute
